import { getAxiosInstance } from '../client';
/** Typed API functions for users/identity domain */
export const usersQueries = {
    /** GET /users/:patientId/video-reach — whether a video appointment would be booked (#1856). */
    getVideoReach: (patientId) => getAxiosInstance()
        .get(`/users/${patientId}/video-reach`)
        .then((r) => r.data),
    /** GET /users/me */
    getCurrentUser: () => getAxiosInstance()
        .get('/users/me')
        .then((r) => r.data),
    /** GET /users/:id/invoices */
    getInvoices: (userId) => getAxiosInstance()
        .get(`/users/${userId}/invoices`)
        .then((r) => r.data),
    /** GET /users/:id/profile */
    getProfile: (userId) => getAxiosInstance()
        .get(`/users/${userId}/profile`)
        .then((r) => r.data),
    /** GET /users/:id/settings */
    getSettings: (userId) => getAxiosInstance()
        .get(`/users/${userId}/settings`)
        .then((r) => r.data),
    /**
     * POST /users/login-address-holder: whose login an address already is in the
     * own office. A read; POST keeps the address out of the request log.
     */
    getLoginAddressHolder: (address) => getAxiosInstance()
        .post('/users/login-address-holder', { address })
        .then((r) => r.data),
    /** GET /users/:id */
    getById: (userId) => getAxiosInstance()
        .get(`/users/${userId}`)
        .then((r) => r.data),
    /** GET /users/:id/custom-forms */
    getAssignedCustomForms: (userId) => getAxiosInstance()
        .get(`/users/${userId}/custom-forms`)
        .then((r) => r.data),
    /**
     * GET /users/:id/custom-form-answers/summaries — every form the patient filled in,
     * newest first, with its form's title but none of its content. One row per answer,
     * so it is not paged.
     */
    getCustomFormAnswerSummaries: (userId) => getAxiosInstance()
        .get(`/users/${userId}/custom-form-answers/summaries`)
        .then((r) => r.data),
    /** GET /users/:id/associationStats */
    getAssociationStats: (userId) => getAxiosInstance()
        .get(`/users/${userId}/associationStats`)
        .then((r) => r.data),
    /** GET /users/:userId/icd10 */
    getUserIcd10: (userId) => getAxiosInstance()
        .get(`/users/${userId}/icd10`)
        .then((r) => r.data),
    /** GET /users/:userId/patient-status/:date */
    getPatientStatus: (userId, date) => getAxiosInstance()
        .get(`/users/${userId}/patient-status/${date}`)
        .then((r) => r.data),
    /** GET /users/:userId/exercise-program-calendar/start/:start/end/:end */
    getExerciseProgramCalendar: (userId, start, end) => getAxiosInstance()
        .get(`/users/${userId}/exercise-program-calendar/start/${start}/end/${end}`)
        .then((r) => r.data),
    /** GET /users/:userId/completed-training-session-items/today */
    getCompletedTrainingSessionItemsToday: (userId) => getAxiosInstance()
        .get(`/users/${userId}/completed-training-session-items/today`)
        .then((r) => r.data),
    /** GET /users/:userId/exercise-programs/count */
    getExerciseProgramCount: (userId) => getAxiosInstance()
        .get(`/users/${userId}/exercise-programs/count`)
        .then((r) => r.data),
    /** GET /users/:userId/patient-count */
    getPatientCount: (userId) => getAxiosInstance()
        .get(`/users/${userId}/patient-count`)
        .then((r) => r.data),
    /** GET /users/:userId/office-locations */
    getOfficeLocations: (userId) => getAxiosInstance()
        .get(`/users/${userId}/office-locations`)
        .then((r) => r.data),
};
/** Query keys for users domain - use with TanStack Query */
export const usersKeys = {
    all: () => ['users'],
    me: () => ['users', 'me'],
    newsletter: () => ['users', 'newsletter'],
    invoices: (userId) => ['users', userId, 'invoices'],
    profile: (userId) => ['users', userId, 'profile'],
    videoReach: (patientId) => ['users', patientId, 'video-reach'],
    settings: (userId) => ['users', userId, 'settings'],
    byId: (userId) => ['users', userId],
    loginAddressHolder: (address) => ['users', 'login-address-holder', address],
    assignedCustomForms: (userId) => ['users', userId, 'custom-forms'],
    associationStats: (userId) => ['users', userId, 'associationStats'],
    icd10: (userId) => ['users', userId, 'icd10'],
    patientStatus: (userId, date) => ['users', userId, 'patient-status', date],
    exerciseProgramCalendar: (userId, start, end) => ['users', userId, 'exercise-program-calendar', start, end],
    patientCount: (userId) => ['users', userId, 'patient-count'],
    officeLocations: (userId) => ['users', userId, 'office-locations'],
    customFormAnswers: (userId) => ['users', userId, 'custom-form-answers'],
};
//# sourceMappingURL=users.queries.js.map